import { useState, useRef, useEffect } from 'react';

export const useWrapperDimensions = (
  wrapperReady: boolean = true
): [React.RefObject<HTMLElement>, { width: number; height: number }] => {
  const wrapperRef = useRef<HTMLElement>(null);

  const [wrapperDimensions, setWrapperDimensions] = useState({
    width: 0,
    height: 0
  });

  useEffect(() => {
    if (!wrapperReady) return;

    if (!wrapperRef.current) return;

    setWrapperDimensions({
      height: wrapperRef.current.clientHeight,
      width: wrapperRef.current.clientWidth
    });
  }, [wrapperReady]);

  return [wrapperRef, wrapperDimensions];
};
